<template>
<content-div>
  <div class="contArea">

    <div class="titWrap">
      <h3 class="conTit1">⁠서비스 해지</h3>
    </div>

    <div class="conTit2">해지 사유를 선택해 주세요.</div>

    <div class="infoTable02">

      <div v-for="(item, key, index) in reasons" :key="key" :class="(index != 0) ? 'mgt1': ''">
        <span class="rdChk">
          <input type="radio" :id="key" :value="key" v-model="reasonSelected">
          <label :for="key"><span>{{item}}</span></label>
        </span>
        <div class="mgt1" v-if="key==Const.SUBSC_STATE_REVOKE_REASON_ETC">
          <textarea
            v-model="reasonWrite"
            :title="item"
            :disabled="reasonSelected!=key"
            style="height: 120px;resize: none;">
          </textarea>
        </div>
      </div>
    </div>

    <div class="titWrap">
      <h3 class="conTit1">서비스 해지 시 예상 환불금액</h3>
    </div>

    <div class="infoTable02 tR fCol2">
      <template v-if="refundPrice == REFUND_NOT_ALLOWED">해지불가</template>
      <template v-else>{{ String(refundPrice) | currency}} 원</template>
    </div>
    <div class="alignR">D-1 금액 상품 사용으로 인해 변경될 수 있습니다.</div>
    <div class="alignR">멤버십 사용내역을 확인 하여 최종 환불 금액이 추후 안내될 예정입니다.</div>

    <div class="infoTable02" v-if="refundPrice != REFUND_NOT_ALLOWED && refundData.use != undefined">
      <ul>
        <li><em>차대번호</em><span>{{subsc.vehicle_num_id}}</span></li>
        <li><em>차량번호</em><span>{{subsc.vehicle_num_reg}}</span></li>
        <li><em>멤버십</em><span>{{subsc.pkg}}</span></li>
        <li v-show="subsc.prodInsurance"><em style="width: 50% !important;">{{$store.state.insuranceName}} 사용</em><span>{{ (refundData.insurance_prod_use) ? '예' : '아니오'}}</span></li>
        <li><em>사용일수</em><span>{{refundData.use}} 일</span></li>
        <li><em>결제금액</em><span>{{ String(subsc.price_payment) | currency}} 원</span></li>

        <template v-if="!refundData.insurance_prod_use">
          <li><em>위약금</em><span>-{{ String(refundData.penalty) | currency }} 원</span></li>
          <li><em>정비사용금액</em><span>-{{ String(refundData.care) | currency }} 원</span></li>
          <li v-show="subsc.prodInsurance"><em>보험일할금액</em><span>-{{ String(refundData.insurance_refund) | currency }} 원</span></li>
        </template>
        
        <li><em>예상 환불금액</em><span class="fCol2">{{ String(refundPrice) | currency}} 원</span></li>
        
      </ul>
    </div>

    <div class="titWrap">
      <h3 class="conTit1">환불 규정 안내</h3>
    </div>

    <div class="infoTable02">
      <ul class="listDot">
        <li>가입 승인 전 해지 신청 시 전액 환불 됩니다.</li>
        <li>가입 후, {{$store.state.insuranceName}} 사용하신 고객은 해지 신청 시 환불 불가하며, 함께 가입한 Standard 또는 Premium 상품도 환불 불가 합니다.</li>
        <li>{{$store.state.insuranceName}}에 가입한 고객이 상품을 해지하는 경우 함께 가입한 Standard 또는 Premium 상품도 해지됩니다.</li>
        <li>가입승인일 익일 00시 14일 이후에 상품 가입 철회의 의사표시를 할 경우, 위약금이 발생합니다.</li>
        <li>Standard, Premium 환불금액 = 구매금액 – 위약금 (구매금액의 10%) – 기제공 서비스 비용 (정상 수리 가격)</li>
        <li>
          {{$store.state.insuranceName}} 구매금액 (미 사용시에 한함) = 구매금액 – 위약금 (구매금액의 10%) – 보험소요비용<br>
          ※ 보험소요비용 = Power Train 구매 금액 x [상품 가입승인일 익일 00시부터 회사가 해지의 의사표시를 수령한 날까지의 기간 ÷ 약정된 서비스 제공기간 (1년)]<br>
          (예: 가입기간 100일 경과한 상태에서 환불을 요청할 경우, 일할 계산된 소요 비용 = 구매금액 x 100일/365일)
        </li>
        <li>정비 이력이 있을 경우 실제 환불처리까지 14일 이상 소요될 수 있으며, 카드사 마다 환급일이 상이합니다.</li>
      </ul>
    </div>

    <ul class="listDot mgt2">
      <li>{{$store.state.msg_}}</li>
    </ul>

    <div class="btnBox fullBtn">
      <a class="btnL" @click="revokeActivate = true;">구독 서비스 해지 신청하기</a>
    </div>

  </div>

  <popup-alert 
    v-if="revokeActivate" 
    title="해지신청"
    btn_cancel
    @close="closeRevoke"
  >
    해지신청 진행하시겠습니까?<br>
    <div v-if="subsc && subsc.state == Const.SUBSC_STATE.ENABLE_REQ">
      가입신청 상태로 즉시 환불처리 됩니다.
    </div>

    <div v-if="refundData.insurance_prod_use">
      {{$store.state.insuranceName}}가 포함된 멤버십 상품은 환불 불가 합니다.
    </div>

  </popup-alert>

  <!-- 알림메세지 popup -->
  <popup-alert v-if="alertActivate" title="알림" @close="closeAlert">
    <span v-html="alertMsg"></span>
  </popup-alert>

  <!-- 해지신청할 구독 선택 및 해지신청 -->
  <popup v-if="activate">

    <template #title>BMW ServiceCare+ 서비스 해지</template>

    <template #content>
      <div>해지를 원하시는 서비스 차량을 선택하세요.</div>
      <table class="tbl-form alignC pm-tbl-form">
        <thead>
          <tr>
            <th >선택</th>
            <th class="WBkeepAll">자동차 등록번호</th>
            <th class="WBkeepAll">서비스 멤버십명</th>
            <th class="WBkeepAll">서비스 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(subsc, index) in subscVehicle" :key="index">
            <th>
              <input v-show="false" type="radio" :id="'revoke-'+index" :value="subsc.subscId" v-model="subscId">
              <label :for="'revoke-'+index"><span v-show="false"></span></label>
            </th>
            <td>{{subsc.vehicle_num_reg}}</td>
            <td>{{subsc.pkg}}</td>
            <td v-if="subsc.state == Const.SUBSC_STATE.ENABLE_REQ && subsc.confirm == Const.SUBSC_CONFIRM.WAIT">
              가입신청중<br>
              {{getDateFormat(subsc.created_at,'YY.MM.DD')}}
            </td>
            <td v-else>
              {{getDateFormat(subsc.date_start, 'YY.MM.DD')}}<br>~{{getDateFormat(subsc.date_stop,'YY.MM.DD')}}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    
    <template #button>
      <span><a @click="closeVehicle(false)">취소</a></span>
      <span><a @click="closeVehicle(true)" class="fCol1">확인</a></span>
    </template>

  </popup>


</content-div>   
</template>


<script>
  import axios from "axios";
  import {api} from "@/api";
  import Const from "../../helpers/Const.js";
  import Format from "../../helpers/Format.js";
  import Popup from '@/components/Popup/Popup.vue';
  import PopupAlert from '@/components/Popup/PopupAlert.vue';

  export default {
    filters: Format,
    components: {
      Popup,
      PopupAlert,
    },

    created() {
      //app or dev check  false -> route notApp
      if(this.$route.query.subsc_id)
        this.$store.commit('setBtnLoading', true);

      this.CheckAppDev();
      this.getUserPrimeVehicles();
    },
    computed: {
      subsc() {
        var subsc = this.subscVehicle.find(subsc => subsc.subscId == this.subscId );
        return (subsc !== undefined) ? subsc : null;
      }
    },

    data() {
      return {
        Const,
        REFUND_NOT_ALLOWED: Const.SUBSC_PAYMENT_PRICE_REFUND_NOT_ALLOWED,

        revokeActivate: false,
        activate: false,
        alertActivate: false,
        alertMsg: '',
        pushUrl: '/',

        reasons: Const.getSubscStateRevokeReason(),
        reasonSelected: Const.SUBSC_STATE_REVOKE_REASON_PROD,
        reasonWrite: '',

        subscId: 0,
        subscVehicle: [],
        refundPrice:0,
        refundData: {},
      };
    },

    methods: {
      closeAlert() {
        this.alertActivate = false;
        if (this.pushUrl) this.$router.push(this.pushUrl);
      },
      
      closeVehicle(data){
        this.activate = false;
        //차량선택 취소시 main으로 이동
        if(!data) this.$router.push('/');
        this.getRefundPrice() // 환불금액 get
      },

      alertRoute(msg, url = false, activate = true){
        this.alertMsg = msg;
        this.pushUrl = url;
        this.alertActivate = activate;
      },

      closeRevoke(bool) {
        this.revokeActivate = false;
        if(bool) this.setRevoke();
      },

      // prime 등록차량 목록 get / 해지가능 구독 확인
      getUserPrimeVehicles() {
        //plus_id 가 없을경우
        // if(!this.$store.state.user.plus_id) {
        if(!this.$store.state.user.vtg_id) {
          this.$store.commit('setPopup401', true);
          return;
        }

        //plus_id가 있지만 token이 존재하지 않을경우 (prime 내 미가입상태)
        if(this.$store.state.user.id == 0){
          this.alertRoute('BMW ServiceCare+에 등록된 차량이 없습니다. 메인화면으로 이동합니다.','/');
          return;
        }
        
        const subsc_id = this.$route.query.subsc_id;

        // 2022-05-04 jeon
        // plus_id 암호화 데이터 전체데이터를 가져와 filter한다 오래걸린다... id변경
        // axios.get(`${api.users}/showByPlusId/${this.$store.state.user.plus_id}`)   
        axios.get(`${api.users}/${this.$store.state.user.id}`)
          .then(({data}) => {
            const vehicles = data.data.vehicles;
            const subscs = data.data.subscs;
            if (vehicles) {
              vehicles.forEach((vehicle) => {
                
                subscs.filter((subsc_f) => subsc_f.vehicle_num_id == vehicle.num_id ).forEach(subsc => {
                  // 현재 구독중/연장신청인 차량만 해지신청 가능
                  if(
                    subsc.options.is_escalation !== true
                    && (
                          subsc.state == Const.SUBSC_STATE.ENABLE_REQ
                          || subsc.state == Const.SUBSC_STATE.ENABLE
                          || subsc.state == Const.SUBSC_STATE.NONE
                      )
                  ) {
                    this.subscVehicle.push({
                      subscId: subsc.id,                    // 해지하고자 하는 구독정보의 id
                      vehicle_num_id: vehicle.num_id,       // 차대번호
                      vehicle_num_reg: vehicle.num_reg,     // 차량등록번호
                      pkg: subsc.pkg.title,                 // 가입패키지
                      prodInsurance: subsc.prodTypeInsurance, // 보험 체크
                      state: subsc.state,                   // 구독 상태
                      confirm: subsc.confirm,               // 검수승인 상태
                      created_at: subsc.created_at,         // 구독 생성일 (가입신청날짜)
                      date_start: subsc.date_start,         // 구독 시작일
                      date_stop: subsc.date_stop,           // 구독 종료일
                      price_payment: subsc.price_payment    // 구독 결제 금액
                    });
                  }
                });
                
              });
              if (this.subscVehicle.length == 0) {
                this.alertRoute('현재 구독중인 차량이 존재하지 않습니다. 메인화면으로 이동합니다.','/');
              } else {
                //구독 번호 전달시 바로 해지 화면 노출 처리
                if(subsc_id) {
                  this.subscId = subsc_id;
                  this.getRefundPrice() // 환불금액 get
                } else {
                  this.subscId = this.subscVehicle[0].subscId;
                  this.activate = true; //차량선택 팝업 on
                }
              }
            } else {
              this.alertRoute('BMW ServiceCare+에 등록된 차량이 없습니다. 메인화면으로 이동합니다.','/');
            }
          })
          .catch((error) => {
            if(error.response.status == 401) {
              this.$store.commit('setPopup401', true);
            } else {
              let msg = 'BMW ServiceCare+에 등록된 차량이 없습니다. 메인화면으로 이동합니다.';
              if (error.response.status == 403) msg = this.errorMsg(error);
              this.alertRoute(msg,'/');
            }

            // if (error.response.status == 403)
            //   this.alertMsg = this.errorMsg(error);
            // else
            //   this.alertMsg = 'BMW Prime에 등록된 차량이 없습니다. 메인화면으로 이동합니다.';
            // this.pushUrl = '/';
            // this.alertActivate = true;
          })
      },

      getRefundPrice() {
        if(this.$store.state.btnLoading) return;
        this.$store.commit('setBtnLoading', true);

        axios.get(`${api.admin.subscs}/getRefundPrice/${this.subscId}`, { params: { 
          revoke_date: this.$moment().format('YYYY-MM-DD'), 
          type: 'app' 
        }})
        .then((res) => {
          let priceRefund = res.data.price_refund;
          let refundData = res.data.refund_data;
          this.refundPrice = priceRefund;
          this.refundData = refundData;
        })
        .catch((error) => {
          this.apiCatch(error);
        })
      },

      // 20.03.19   sang
      // 예외처리/ axios 로 subscs data 불러와서 state 가 해지신청일 경우 이미 해지신청중인 구독입니다 팝업 후 라우팅
      // 추가기능/ 버튼 클릭 시 해지신청진행하시겠습니까 안내메세지 한 번 띄우기
      setRevoke() {
        this.$store.commit('setBtnLoading', true);

        const revokeReason = {
          revoke_reason_key: this.reasonSelected,
          revoke_reason_text: this.reasons[this.reasonSelected],
          revoke_reason_write: this.reasonWrite
        }

        const revokeParam = {
          'state_req': Const.SUBSC_STATE_REQ.DISABLE_REVOKE,
          'app_options': revokeReason,
        }

        axios.put(`${api.subscs}/${this.subscId}`, revokeParam)
          .then(() => {
            
            const vmi = (this.subscVehicle.find(subsc => subsc.subscId == this.subscId ).vehicle_num_id);
            const url = `/subscStatusVtg?vtg_id=${this.$store.state.vtg_id}&vehicle_id=${vmi}`;

            this.alertRoute('해지신청이 완료되었습니다. <br> My BMW ServiceCare+에서 해지 처리 진행 상황을 확인하실 수 있습니다.',url);
          })
          .catch((error) => {

            if(error.response.status == 401) {
              this.$store.commit('setPopup401', true);
            } else {
              this.alertRoute(this.errorMsg(error));
            }
          });
      },
    },

    //watch: { 'reasonSelected'(val) { alert(val) } },
  };
</script>


<style lang="css" scoped>
  textarea {
    border: 1px solid #393c3d;
  }
</style>
